(() => {
  const bar = document.querySelector('[data-pdp-floating-atc]');
  const section = document.getElementById('pdp-header-container');
  if (!bar || !section) return;

  const formId = bar.dataset.productForm;
  const mainSubmit = document.querySelector(`#${formId} [name="add"]`);
  const mainLabel = mainSubmit?.querySelector('.product-form__submit-label');
  const floatingSubmit = bar.querySelector('[data-pdp-floating-atc-submit]');
  const floatingLabel = bar.querySelector('[data-pdp-floating-atc-label]');
  const floatingWishlist = bar.querySelector('[data-pdp-floating-atc-wishlist]');
  const mq = window.matchMedia('(min-width: 1024px)');

  const getWishlistButton = () =>
    document.querySelector('#swish-button-block .wk-button') ||
    document.querySelector('#swish-button-block button');

  const syncWishlistSelected = () => {
    if (!floatingWishlist) return;
    const wishlistButton = getWishlistButton();
    floatingWishlist.classList.toggle(
      'is-selected',
      Boolean(wishlistButton?.classList.contains('wk-selected'))
    );
  };

  const sync = () => {
    if (!mq.matches || section.getBoundingClientRect().bottom > 0) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;

    if (mainSubmit && floatingSubmit && floatingLabel && mainLabel) {
      floatingLabel.textContent = mainLabel.textContent;
      floatingSubmit.disabled = mainSubmit.classList.contains('tw-hidden');
    }

    syncWishlistSelected();
  };

  const proxy = document.createElement('select');
  proxy.className = 'pdp-floating-atc__select-proxy';
  proxy.hidden = true;
  floatingSubmit?.insertAdjacentElement('afterend', proxy);
  let proxyTarget = null;

  const syncProxy = () => {
    proxyTarget = Array.from(document.querySelectorAll('variant-selects select')).find((el) => !el.value) || null;
    proxy.hidden = !proxyTarget || !mainSubmit?.disabled;
    if (proxy.hidden) return;
    proxy.innerHTML = proxyTarget.innerHTML;
    proxy.setAttribute('aria-label', proxyTarget.labels?.[0]?.textContent.trim() || '');
  };

  proxy.addEventListener('change', () => {
    if (!proxyTarget) return;
    proxyTarget.value = proxy.value;
    proxyTarget.dispatchEvent(new Event('change', { bubbles: true }));
  });

  floatingSubmit?.addEventListener('click', () => {
    if (!mainSubmit) return;

    if (mainSubmit.disabled) {
      if (!proxy.hidden) proxy.focus();
      return;
    }

    mainSubmit.click();
  });

  floatingWishlist?.addEventListener('click', () => {
    getWishlistButton()?.click();
  });

  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  mq.addEventListener?.('change', sync);

  if (mainLabel) {
    new MutationObserver(sync).observe(mainLabel, { childList: true, characterData: true, subtree: true });
  }
  if (mainSubmit) {
    new MutationObserver(() => {
      syncProxy();
      sync();
    }).observe(mainSubmit, { attributes: true, attributeFilter: ['disabled', 'class'] });
  }

  const wishlistBlock = document.querySelector('#swish-button-block');
  if (wishlistBlock) {
    new MutationObserver(syncWishlistSelected).observe(wishlistBlock, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  syncProxy();
  sync();
})();
